import { Avatar, Divider } from "@material-ui/core";
import React, { useState } from "react";
import "../css/CreatePost.css";
import { useStateValue } from "../StateProvider";
import db, { storage } from "../firebase";
import firebase from "firebase";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

function CreatePost({ onCloseModal }) {
  const [{ user, userProfile }] = useStateValue();
  const [input, setInput] = useState("");
  const [image, setImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  const [progress, setProgress] = useState("");
  const [showProgress, setShowProgress] = useState(false);

  const selectPhoto = (e) => {
    if (e.target.files[0]) {
      setPreviewImage(URL.createObjectURL(e.target.files[0]));
      setImage(e.target.files[0]);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (input) {
      if (image) {
        const uploadTask = storage.ref(`images/${image.name}`).put(image);
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            //progress function
            const progress = Math.round(
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            );
            setProgress(progress);
            setShowProgress(true);
          },
          (error) => {
            //error function....
            console.log(error);
            alert(error.message);
          },
          () => {
            //complete function
            storage
              .ref("images")
              .child(image.name)
              .getDownloadURL()
              .then((url) => {
                //post image inside db
                db.collection("posts").add({
                  message: input,
                  timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                  postedBy: {
                    name: userProfile.name,
                    profilePic: user.photoURL,
                    uid: userProfile.uid,
                    username: userProfile.username,
                  },
                  image: url,
                  likes: [],
                  comments: [],
                });

                setProgress(0);
                setInput("");
                setImage(null);
                setShowProgress(false);
                onCloseModal();
              });
          }
        );
      } else {
        db.collection("posts").add({
          message: input,
          timestamp: firebase.firestore.FieldValue.serverTimestamp(),
          postedBy: {
            name: userProfile.name,
            profilePic: user.photoURL,
            uid: userProfile.uid,
            username: userProfile.username,
          },
          image: "",
          likes: [],
          comments: [],
        });
        setInput("");
        onCloseModal();
      }
    } else {
      alert("input is required!");
    }
  };

  return (
    <div className="createPost">
      <div className="createPost__header">
        <ArrowBackIcon onClick={onCloseModal} />
        <h3>Create Post</h3>
      </div>

      <Divider />
      <div className="createPost__top">
        <Avatar src={user.photoURL} />
        <h4>{userProfile.name}</h4>
      </div>
      <div className="createPost__body">
        <form>
          <textarea
            className="createPost__textArea"
            placeholder="What's on your mind"
            onChange={(e) => setInput(e.target.value)}
            value={input}
          ></textarea>
          {previewImage && (
            <div className="createPost__scrollContainer">
              <img src={previewImage} width="100%" alt="" />
            </div>
          )}
          <input
            className="createPost__browse"
            type="file"
            onChange={selectPhoto}
          />

          <button onClick={handleSubmit} className="createPost__button">
            Post
          </button>
        </form>

        <div className="createPost__progress">
          {showProgress && (
            <progress
              className="imageupload__progress"
              value={progress}
              max="100"
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default CreatePost;
